import React, { useEffect, useState } from "react";
import { getSortedArray } from "../../../../../utils/array.utils";
import { getAllGateways } from "../../../../../redux/user/actions";
import GatewayCard from "../../../../components/gateways/GatewayCard";
import { useNavigate } from "react-router-dom";
import DynamicManualWithdrawGtw from "./gateway";
import HeaderAfterLogin from "../../../../../containers/HeaderAfterLogin";
import { Container, Tab, Tabs } from "react-bootstrap";

const DynamicManualWithdrawList = () => {
  const [gtwList, setGtwList] = useState([]);
  const [activeGtwId, setActiveGtwId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getGatewaysFromServer();
  }, []);

  // Get gtw list from server
  const getGatewaysFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      const sortedArray = getSortedArray({
        arrayToBeSort: response?.data?.data?.data?.withdraws,
        sortKey: "order",
      });
      setGtwList(sortedArray);

      // Below code can we used if modal
      if (sortedArray.length === 1) {
        setActiveGtwId(sortedArray?.[0]?.id);
      }
    }
  };

  const handleGtwClick = (gtw) => {
    // setActiveGtwId(gtw?.id);
    navigate(`/withdraw/gateways/${gtw.id}`);
  };

  return (
    <>
      <div className="">
        <main className="main">
          <div className="gatewaySection">
            <div className="gatewaypart" style={{ display: "flex" }}>
              {gtwList?.map((item, index) => {
                return (
                  <GatewayCard
                    idx={index}
                    gtw={item}
                    key={index}
                    onClick={handleGtwClick}
                  />
                );
              })}
              {/* <Tabs defaultActiveKey={"Withdraw"}>
                <Tab
                  eventKey="Withdraw"
                  title="Dynamic withdraw"
                  className="bank_deposit_class"
                >
                  {gtwList?.map((item, index) => {
                    return (
                      <GatewayCard
                        idx={index}
                        gtw={item}
                        key={index}
                        onClick={handleGtwClick}
                      />
                    );
                  })}
                </Tab>
              </Tabs> */}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};
export default DynamicManualWithdrawList;
